/**
 * The note under a PitchBook company that names neither a website nor a
 * LinkedIn page: neither key the automatic matching joins it to its ChopLink
 * company by (epic 2026-10-06-chopbook-real-page-and-matching, sub-task 04).
 * Shown on the list row and in the company side panel.
 */

/** A PitchBook company with neither key the matching needs. */
export function hasNoWebsiteOrLinkedin(company: {
  pitchbook_id?: string | null;
  url?: string | null;
  linkedin_url?: string | null;
}): boolean {
  return Boolean(company.pitchbook_id) && !company.url && !company.linkedin_url;
}

export const NO_WEBSITE_OR_LINKEDIN = "PitchBook has no website or LinkedIn page for this company";

export function NoWebsiteOrLinkedinNote({ className = "" }: { className?: string }) {
  return (
    <span
      className={`text-caption text-text-muted ${className}`}
      data-testid="no-website-or-linkedin"
    >
      {NO_WEBSITE_OR_LINKEDIN}
    </span>
  );
}
